"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.segmentValuesToTimeString = exports.partialTimeStringToSegmentValuesWithPeriod = exports.partialSegmentValuesWithPeriodToTimeString = exports.isValidTimeString = exports.isValidPeriod = exports.getTimeSegmentsFromDateString = exports.getTimeMaskPlaceholder = exports.getSegmentValuesFromDayjs = exports.getPopupTimePickerPlaceholder = exports.getPopupTimePickerMaskPlaceholder = exports.getDefaultInvalidValueErrorText = exports.getDayjsTimeMask = exports.fullTimeStringToSegmentValues = exports.forceTwoDigits = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

var _customParseFormat = _interopRequireDefault(require("dayjs/plugin/customParseFormat"));

var _objectSupport = _interopRequireDefault(require("dayjs/plugin/objectSupport"));

var _constants = require("./constants");

_dayjs.default.extend(_customParseFormat.default);

_dayjs.default.extend(_objectSupport.default);

var getTimeSegmentsFromDateString = function getTimeSegmentsFromDateString(dateTimeString, showSeconds, showMilliseconds) {
  var segments = {};

  if (dateTimeString) {
    var date = (0, _dayjs.default)(dateTimeString.replace(/[a-zA-Z]/g, '0'));
    var showSegmentsLength = 2;

    if (showSeconds) {
      showSegmentsLength++;

      if (showMilliseconds) {
        showSegmentsLength++;
      }
    }

    Object.keys(_constants.timeSegmentMaskKeys).slice(0, showSegmentsLength).forEach(function (timeSegmentKey) {
      var functionKey = timeSegmentKey.substr(0, timeSegmentKey.length - 1);
      var segmentValue = date[functionKey]();
      segments[timeSegmentKey] = segmentValue || 0;
    });
  }

  return segments;
};

exports.getTimeSegmentsFromDateString = getTimeSegmentsFromDateString;

var getTimeMaskPlaceholder = function getTimeMaskPlaceholder(dateMaskPlaceholder, _ref) {
  var showMilliseconds = _ref.showMilliseconds,
      showSeconds = _ref.showSeconds,
      showTime = _ref.showTime;
  var maskPlaceholder = dateMaskPlaceholder;

  if (showTime) {
    // No need to have RTL symbols in the mask as the component should be wrapped in an RTL context
    maskPlaceholder = "".concat(maskPlaceholder.replace(/\u200f/g, ''), " ").concat(_constants.timeSegmentMaskKeys.hours, ":").concat(_constants.timeSegmentMaskKeys.minutes);

    if (showSeconds) {
      maskPlaceholder += ":".concat(_constants.timeSegmentMaskKeys.seconds);

      if (showMilliseconds) {
        maskPlaceholder += ".".concat(_constants.timeSegmentMaskKeys.milliseconds);
      }
    }
  }

  return maskPlaceholder;
};

exports.getTimeMaskPlaceholder = getTimeMaskPlaceholder;

var getPopupTimePickerPlaceholder = function getPopupTimePickerPlaceholder(is24Hours) {
  return "hh:mm".concat(is24Hours ? '' : ' AM/PM');
};

exports.getPopupTimePickerPlaceholder = getPopupTimePickerPlaceholder;

var getPopupTimePickerMaskPlaceholder = function getPopupTimePickerMaskPlaceholder(is24Hours) {
  return "--:--".concat(is24Hours ? '' : ' --');
};

exports.getPopupTimePickerMaskPlaceholder = getPopupTimePickerMaskPlaceholder;

var getDefaultInvalidValueErrorText = function getDefaultInvalidValueErrorText(is24Hours) {
  return "The provided value is not a valid time. The correct time format is hour:minute".concat(is24Hours ? '' : ' AM/PM', ".");
};

exports.getDefaultInvalidValueErrorText = getDefaultInvalidValueErrorText;

var forceTwoDigits = function forceTwoDigits(value) {
  var str = value.toString();
  if (str.length === 1) str = "0".concat(str);
  return str;
}; // https://day.js.org/docs/en/display/format


exports.forceTwoDigits = forceTwoDigits;

var getDayjsTimeMask = function getDayjsTimeMask(is24Hours) {
  return is24Hours ? 'HH:mm' : 'hh:mm A';
};

exports.getDayjsTimeMask = getDayjsTimeMask;

var partialSegmentValuesWithPeriodToTimeString = function partialSegmentValuesWithPeriodToTimeString(segmentValues, is24Hours) {
  var hour = segmentValues.hours !== undefined ? forceTwoDigits(segmentValues.hours) : '--';
  var minute = segmentValues.minutes !== undefined ? forceTwoDigits(segmentValues.minutes) : '--';
  var period = segmentValues.period !== undefined ? segmentValues.period : '--';
  return "".concat(hour, ":").concat(minute).concat(is24Hours ? '' : " ".concat(period));
};

exports.partialSegmentValuesWithPeriodToTimeString = partialSegmentValuesWithPeriodToTimeString;

var partialTimeStringToSegmentValuesWithPeriod = function partialTimeStringToSegmentValuesWithPeriod(value, is24Hours) {
  var hour = value.substring(0, 2);
  var minute = value.substring(3, 5);
  var period = is24Hours ? '-' : value.substring(6, 8);
  return {
    hours: hour.includes('-') ? undefined : parseInt(hour),
    minutes: minute.includes('-') ? undefined : parseInt(minute),
    period: isValidPeriod(period) ? period : undefined
  };
};

exports.partialTimeStringToSegmentValuesWithPeriod = partialTimeStringToSegmentValuesWithPeriod;

var segmentValuesToTimeString = function segmentValuesToTimeString(segmentValues, is24Hours) {
  var hour = segmentValues.hours || 0;
  var minute = segmentValues.minutes || 0; // Parsing objects requires the objectSupport plugin but it doesn't
  // change the base dayjs type, resulting in a false error here
  // TODO: Fixed in dayjs 1.11.4 https://github.com/iamkun/dayjs/issues/1441
  // @ts-ignore

  var time = (0, _dayjs.default)({
    hour: hour,
    minute: minute
  });
  return time.format(getDayjsTimeMask(is24Hours));
};

exports.segmentValuesToTimeString = segmentValuesToTimeString;

var getSegmentValuesFromDayjs = function getSegmentValuesFromDayjs(day) {
  return {
    hours: day.hour(),
    minutes: day.minute()
  };
};

exports.getSegmentValuesFromDayjs = getSegmentValuesFromDayjs;

var isValidPeriod = function isValidPeriod(period) {
  return period === 'AM' || period === 'PM';
};

exports.isValidPeriod = isValidPeriod;

var fullTimeStringToSegmentValues = function fullTimeStringToSegmentValues(value, is24Hours) {
  var day = (0, _dayjs.default)(value, getDayjsTimeMask(is24Hours));
  return getSegmentValuesFromDayjs(day);
};

exports.fullTimeStringToSegmentValues = fullTimeStringToSegmentValues;

var isValidTimeString = function isValidTimeString(value, is24Hours) {
  if (!(is24Hours ? _constants.REGEXP_TIME_24H.test(value) : _constants.REGEXP_TIME_12H.test(value))) return false;

  var _partialTimeStringToS = partialTimeStringToSegmentValuesWithPeriod(value, is24Hours),
      hours = _partialTimeStringToS.hours,
      minutes = _partialTimeStringToS.minutes,
      period = _partialTimeStringToS.period;

  if (hours === undefined || minutes === undefined) return false;
  if (minutes < 0 || minutes > 59) return false;

  if (is24Hours) {
    if (hours < 0 || hours > 23) return false;
  } else {
    if (hours < 1 || hours > 12) return false;
    if (period === undefined) return false;
  }

  return true;
};

exports.isValidTimeString = isValidTimeString;